import { useApiMutation } from '@/modules/common';

import { TextStyleItem } from '../types';

export function useCreateTextStyle() {
  const createTextStyleMutation = useApiMutation<TextStyleItem>('/text-styles', {
    method: 'POST',
  });

  return { createTextStyleMutation } as const;
}
